import React from 'react';

export type DonutSegment = {
  label: string;
  value: number;
  color: string;
};

interface DonutChartProps {
  segments: DonutSegment[];
  size?: number;
  strokeWidth?: number;
  centerLabel?: {
    title: string;
    value: string;
  };
}

const DonutChart: React.FC<DonutChartProps> = ({
  segments,
  size = 140,
  strokeWidth = 14,
  centerLabel,
}) => {
  const total = segments.reduce((acc, s) => acc + (Number.isFinite(s.value) ? s.value : 0), 0);
  const safeTotal = total > 0 ? total : 1;
  const r = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * r;

  let offset = 0;

  return (
    <div className="donut-wrap" aria-label="Gráfico donut">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="donut-svg">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="rgba(255,255,255,0.10)"
          strokeWidth={strokeWidth}
        />

        <g transform={`rotate(-90 ${size / 2} ${size / 2})`}>
          {segments.map((seg) => {
            const value = Number(seg.value) || 0;
            if (value <= 0) return null;

            const fraction = value / safeTotal;
            const dash = fraction * circumference;
            const gap = circumference - dash;
            const strokeDasharray = `${dash} ${gap}`;
            const strokeDashoffset = -offset;
            offset += dash;

            return (
              <circle
                key={seg.label}
                cx={size / 2}
                cy={size / 2}
                r={r}
                fill="none"
                stroke={seg.color}
                strokeWidth={strokeWidth}
                strokeDasharray={strokeDasharray}
                strokeDashoffset={strokeDashoffset}
                strokeLinecap="round"
              />
            );
          })}
        </g>
      </svg>

      {centerLabel && (
        <div className="donut-center">
          <div className="donut-center-title">{centerLabel.title}</div>
          <div className="donut-center-value">{centerLabel.value}</div>
        </div>
      )}
    </div>
  );
};

export default DonutChart;

